//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { createBranchInvoiceValidationForm } from "../../utils/validationSchemas";
import BranchInvoiceForm from "./BranchInvoiceForm";

const EditBranchInvoice = (props: any) => {
  const { handleEdit, isLoading } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createBranchInvoiceValidationForm),
  });
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Save"}
      isLoading={isLoading}
    >
      <BranchInvoiceForm />
    </FormLayout>
  );
};

export default EditBranchInvoice;
